<mat-form-field  style="width: 100%;" [formGroup]="group">
  <mat-select [placeholder]="field.label" [formControlName]="field.name">
    <mat-option *ngIf="group.get(field.name).value" [value]= "null">Clear</mat-option>
    <mat-option *ngFor="let item of field.options" [value]="item.value">{{item.label}}</mat-option>
  </mat-select>
</mat-form-field>
